import { render, staticRenderFns } from "./ResTextField.vue?vue&type=template&id=5955bc20&scoped=true"
import script from "./ResTextField.vue?vue&type=script&lang=js"
export * from "./ResTextField.vue?vue&type=script&lang=js"
import style0 from "./ResTextField.vue?vue&type=style&index=0&id=5955bc20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5955bc20",
  null
  
)

export default component.exports